import { z } from 'zod';
import { reactSelectOptionSchema } from '../../lib/zod-util';
import { LoadingUnit, MarginUnit } from '../../graphql';
import { contractDetailsSchema } from '../voyageCharter/schema';

export const batchEditFieldsSchema = z.object({
  contract: contractDetailsSchema.nullable().optional(),
  dischargePortId: reactSelectOptionSchema.nullable().optional(),
  loadPortId: reactSelectOptionSchema.nullable().optional(),
  assortmentId: z.number().nullable().optional(),
  cargoAmount: z.number().nullable().optional(),
  cargoUnitId: z.number().nullable().optional(),
  loadingRate: z.number().nullable().optional(),
  loadingUnit: z.nativeEnum(LoadingUnit).optional().nullable(),
  dischargingRate: z.number().nullable().optional(),
  dischargingUnit: z.nativeEnum(LoadingUnit).nullable().optional(),
  marginAmount: z.number().nullable().optional(),
  marginUnit: z.nativeEnum(MarginUnit).optional().nullable(),
  chartererOrgId: reactSelectOptionSchema.nullable().optional(),
  layday: z.date().nullable().optional(),
  cancelling: z.date().nullable().optional(),
});

export type BatchEditFields = z.infer<typeof batchEditFieldsSchema>;
